export default __webpack_public_path__ + "files/state-portal-37f0af4e2aacfe62c772913afaff2e6d.jpg";